<template>
  <transition name="el-zoom-in-top">
    <el-card v-show="update.show" class="box-card" style="text-align: left;">
      <div slot="header" class="clearfix">
        <el-row>
          <el-col :span="12">
            <h3>修改工单</h3>
          </el-col>
          <el-col :span="12">
            <el-button style="float: right;" type="primary" @click="update.show=false">收起</el-button>
          </el-col>
        </el-row>
      </div>
      <el-form
        ref="update.form"
        :model="update.form"
        label-width="110px"
        style="width:100%"
        :rules="rules"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="工单号" prop="orderno">
              <el-input v-model="update.form.orderno" style="width:90%" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="计划生产日期" prop="plan_date">
            <el-date-picker
              style="width: 90%"
                v-model="update.form.plan_date"
                type="date"
                value-format="yyyy-MM-dd"
                format="yyyy 年 MM 月 dd 日"
                placeholder="选择日期"
              >
              </el-date-picker>
              </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="工单类型" prop="orderno_type">
              <el-select v-model="update.form.orderno_type" type="text" style="width:90%">
                <el-option
                  v-for="item in orderstatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="工厂" prop="factory_code">
              <el-select
                v-model="update.form.factory_code"
                type="text"
                filterable
                style="width:90%"
                @change="getworkshoplistsearch(update.form.factory_code)"
              >
                <el-option
                  v-for="(item,index) in factorylist"
                  :key="index"
                  :label="item.factory_name"
                  :value="item.factory_code"
                />
              </el-select>
            </el-form-item>
          </el-col>

        <el-col :span="6">
          <el-form-item label="车间" prop="workshop_code">
            <el-select v-model="update.form.workshop_code" type="text" clearable filterable style="width: 90%"
                       @change="getworklinelistlistsearch()">
              <el-option v-for="(item, index) in workshoplist" :key="index" :label="item.workshop_name"
                         :value="item.workshop_code" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="产线" prop="workline_code">
            <el-select v-model="update.form.workline_code" type="text" clearable filterable style="width: 90%">
              <el-option v-for="(item, index) in worklinelist" :key="index" :label="item.workline_name"
                         :value="item.workline_code" />
            </el-select>
          </el-form-item>
        </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item v-show="update.form.orderno_type == 2" label="委托客户编码" prop="entrust_code">
              <el-input v-model.number="update.form.entrust_code" disabled style="width:90%" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <!-- 填写具体奖项 -->
        <h4>产品记录</h4>
        <br />
        <el-row>
          <el-col :span="11">
            <el-card shadow="never">
              <el-form
                ref="productform"
                :model="productform"
                label-width="140px"
                style="width:80%"
                :rules="rules"
              >
                <el-form-item label="产品" prop="product_code">
                  <el-select
                    v-model="productform.product_code"
                    placeholder="请输入产品名称"
                    style="width:70%"
                    :remote-method="getproductlist"
                    filterable
                    remote
                    :loading="productloading"
                    @change="getprodcutname($event)"
                  >
                    <el-option
                      v-for="item in productlist"
                      :key="item.product_code"
                      :label="item.product_name"
                      :value="item.product_code"
                     >
                    <span style="float: left">{{ item.product_code }}</span>
      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.product_name }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
                 <el-form-item label="批次号" prop="batchno">
              <el-input v-model="productform.batchno" style="width:70%" />
            </el-form-item>
                <el-form-item label="计划生产数量" prop="product_quantity">
                  <el-input v-model.number="productform.product_quantity" style="width:70%" />
                </el-form-item>
              </el-form>
              <div style="text-align: center;">
                <el-button style="margin-top: 12px;" @click="resetForm('productform')">重置</el-button>
                <el-button
                  style="margin-top: 12px;"
                  type="primary"
                  @click="productadd('productform')"
                >生成</el-button>
              </div>
            </el-card>
          </el-col>
          <el-col :span="2" style="text-align:center">
            <el-button size="medium" style="margin-top: 100px;" class="el-icon-d-arrow-right" />
          </el-col>
          <el-col :span="11">
            <el-card shadow="never">
              <el-table
                :data="update.tablelist"
                height="224"
                stripe
                style="width: 100%"
                @cell-click="danghang"
              >
                <el-table-column prop="product_code" label="产品编码" show-overflow-tooltip />
                <el-table-column prop="batchno" label="批次号" show-overflow-tooltip />
                <el-table-column prop="product_quantity" label="计划生产数量" min-width="100" />
                <el-table-column prop="address" label="操作" width="80">
                  <template slot-scope="scope">
                    <el-button-group>
                      <el-button
                        type="danger"
                        @click.native.prevent="deleteRow(scope.$index, update.tablelist)"
                      >删除</el-button>
                    </el-button-group>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
        <div style="text-align: center;">
          <el-button style="margin-top: 12px;" type="primary" @click="submitadd('update.form')">提交</el-button>
        </div>
      </div>
    </el-card>
  </transition>
</template>

<script>
import {
  workupdate,
  factorylist,
  worklinelist,
  workshoplist,
} from "@/api/plant";
import { productlist } from "@/api/base";
import { type } from "os";
export default {
  props: {
    search: {
      type: Function,
      default: null,
    },
    update: {
      type: Object,
      default: () => {
        return {
          show: false,
          // 表格数据
          tablelist: [],
          form: {
            orderno: null,
            batchno: null,
            orderno_type: null,
            factory_code: null,
            workshop_code: null,
            workline_code: null,
            plan_date: null,
            entrust_code: null,
          },
        };
      },
    },
  },
  data() {
    return {
      // 基础数据
      orderstatus: [
        {
          value: 0,
          label: "自有工单",
        },
        {
          value: 1,
          label: "外协工单",
        },
        {
          value: 2,
          label: "委托加工",
        },
      ],
      show: true,
      productloading: false,
      productlist: [], // 产品列表下拉
      factorylist: [],
      workshoplist: [],
      worklinelist: [],
      productform: {
        // 步骤1 表单
        product_code: null,
        product_quantity: null,
      },
      rules: {
        orderno: [
          { required: true, message: "工单号", trigger: "blur" },
          { validator: this.$validateaccount, trigger: "blur" },
        ],
        batchno: [
          { required: true, message: "批次号", trigger: "blur" },
          { validator: this.$validateaccount, trigger: "blur" },
        ],
        orderno_type: [
          { required: true, message: "请输入工单类型", trigger: "blur" },
        ],
        factory_code: [
          { required: true, message: "请输入工厂编码", trigger: "blur" },
        ],

        product_code: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
        ],
        product_quantity: [
          { required: true, message: "请输入计划生产数量", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    // 下拉
    this.getproductlist(); // 产品下拉
    this.getfactorylst();
  },
  methods: {
    // 获取产品下拉
    getproductlist(value) {
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value }).then((response) => {
            this.productlist = response.data.data;
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    getfactorylst() {
      factorylist({ pageSize: 10000 }).then((response) => {
        this.factorylist = response.data.data;
        for (let c = 0; c < this.factorylist.length; c++) {
          this.factorylist[c].factory_name =
            this.factorylist[c].factory_code +
            "|" +
            this.factorylist[c].factory_name;
        }
      });
    },
    // 车间下拉
    getworkshoplistsearch(value) {
      this.update.form.workshop_code = "";
      this.update.form.workline_code = "";
      workshoplist({
        factory_code: this.update.form.factory_code,
        workorder_status: 0,
        pageSize: 1000,
      }).then((response) => {
        this.workshoplist = response.data.data;
        for (let i = 0; i < this.workshoplist.length; i++) {
          this.workshoplist[i].workshop_name =
            this.workshoplist[i].workshop_code +
            "|" +
            this.workshoplist[i].workshop_name;
        }
      });
    },
    getworklinelistlistsearch(value) {
      // 产线下拉
      this.update.form.workline_code = "";
      worklinelist({
        workshop_code: value,
        workorder_status: 0,
        pageSize: 1000,
      }).then((response) => {
        this.worklinelist = response.data.data;
        for (let b = 0; b < this.worklinelist.length; b++) {
          this.worklinelist[b].workline_name =
            this.worklinelist[b].workline_code +
            "|" +
            this.worklinelist[b].workline_name;
        }
      });
    },
    // 把产品添加到表格
    productadd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const obj = {};
          obj["product_code"] = this.productform.product_code;
          obj['batchno'] = this.productform.batchno;
          obj["product_quantity"] = this.productform.product_quantity;
          for (let i = 0; i < this.update.tablelist.length; i++) {
            // 产品不能重复
            if (
              this.update.tablelist[i].product_code ==
              this.productform.product_code
            ) {
              this.update.tablelist[
                i
              ].product_quantity += this.productform.product_quantity;
              this.$refs[formName].resetFields();
              return;
            }
          }
          this.update.tablelist.push(obj);
          this.$refs[formName].resetFields();
        } else {
          return false;
        }
      });
    },
    // 表格行删除
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    danghang(row) {
      console.log(row);
    },
    // 根据产品编码获取名称
    getprodcutname(productCode) {
      this.productform.product_unit = "";
      if (this.productform.product_code.length !== 0) {
        productlist({ productCode: this.productform.product_code }).then(
          (response) => {
            if (response.data.data.length == 0) {
              this.$message({
                type: "warning",
                message: "产品编码不存在！",
              });
            } else {
              this.productform.product_unit =
                response.data.data[0].min_pack_unit;
            }
          }
        );
      }
    },
    // 保存提交
    submitadd(formName) {
      // console.log(this.update)
      this.$refs[formName].validate((valid) => {
        // 基础表单验证
        if (valid) {
          workupdate({
            orderno: this.update.form.orderno,
            batchno: this.update.form.batchno,
            orderno_type: this.update.form.orderno_type,
            factory_code: this.update.form.factory_code,
            workshop_code: this.update.form.workshop_code,
            workline_code: this.update.form.workline_code,
            plan_date: this.update.form.plan_date,
            workorderProducts: this.update.tablelist,
          }).then((response) => {
            if (response.status_code == 200) {
              this.$message({
                type: "success",
                message: "提交成功!",
              });
              this.search();
              this.update.tablelist = [];
              this.resetForm(formName);
            } else {
              this.$message({
                type: "warning",
                message: "提交失败!请检查字段",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
